/**
 * 后台外壳里互动小说的几处文案：导航项、导航分组、计费动作名与说明，日文另有服务凭据池的数字人类型名。日、西、葡界面的
 * 其余外壳沿用英文，这几处属于互动小说，要译（R-15）。
 */
export const novelShellJa = {
  nav: { novelPacks: '小説作品', novelRuns: '小説のプレイ記録', group: 'インタラクティブ小説' },
  actionNames: { novel_turn: '小説のターン', novel_correction: '思い出帳の訂正', novel_drama_session: '小説のデジタルヒューマン演出' },
  actionHints: {
    novel_turn: 'インタラクティブ小説でターンまたは再生成を送信するたびに仮押さえするポイント。生成に失敗すると自動で返却されます。',
    novel_correction: 'インタラクティブ小説のプレイヤーが根拠つきの思い出帳の訂正を送信したときに仮押さえするポイント。記録や根拠が無効、確認で却下、または失敗した場合は自動で返却されます。',
    novel_drama_session: 'インタラクティブ小説のデジタルヒューマン演出 1 回（1 ターンに 1 回）ごとに仮押さえするポイント。最初のフレームより前に失敗すると自動で返却されます。',
  },
  // 服务凭据池的能力类型：数字人凭据（avatar:vidu）的类型名译成日文；西、葡外壳不带这项，Avatar 与英文同词沿用。
  capabilityTypes: { avatar: 'デジタルヒューマン' },
}

export const novelShellEs = {
  nav: { novelPacks: 'Obras de novela', novelRuns: 'Partidas de novela', group: 'Novela interactiva' },
  actionNames: { novel_turn: 'Turno de novela', novel_correction: 'Corrección de recuerdos', novel_drama_session: 'Actuación del avatar de novela' },
  actionHints: {
    novel_turn: 'Puntos reservados por cada turno o regeneración enviados en la novela interactiva; se devuelven automáticamente si la generación falla.',
    novel_correction: 'Puntos reservados cuando un jugador de la novela interactiva envía una corrección de recuerdos con pruebas; se devuelven automáticamente si el registro o las pruebas no son válidos, la revisión la rechaza o falla.',
    novel_drama_session: 'Puntos reservados por cada actuación del avatar en la novela interactiva (una por turno); se devuelven automáticamente si falla antes del primer fotograma.',
  },
}

export const novelShellPt = {
  nav: { novelPacks: 'Obras de romance', novelRuns: 'Partidas de romance', group: 'Romance interativo' },
  actionNames: { novel_turn: 'Turno de romance', novel_correction: 'Correção de memórias', novel_drama_session: 'Atuação do avatar de romance' },
  actionHints: {
    novel_turn: 'Pontos reservados a cada turno ou regeneração enviados no romance interativo; devolvidos automaticamente se a geração falhar.',
    novel_correction: 'Pontos reservados quando um jogador do romance interativo envia uma correção de memórias com evidências; devolvidos automaticamente se o registro ou as evidências forem inválidos, a verificação recusar ou falhar.',
    novel_drama_session: 'Pontos reservados a cada atuação do avatar no romance interativo (uma por turno); devolvidos automaticamente se falhar antes do primeiro quadro.',
  },
}

/**
 * 把外壳译文写进一份克隆出来的后台文案（只改这几处的值，键结构不变）。
 * @param {Record<string, any>} admin structuredClone(en).visualGameAdmin
 * @param {typeof novelShellJa} shell
 */
export function withNovelShell(admin, shell) {
  admin.app.novelPacks = shell.nav.novelPacks
  admin.app.novelRuns = shell.nav.novelRuns
  admin.app.groups.novel = shell.nav.group
  Object.assign(admin.billing.actionNames, shell.actionNames)
  Object.assign(admin.billing.actionHints, shell.actionHints)
  if (shell.capabilityTypes) Object.assign(admin.llm.capabilities.types, shell.capabilityTypes)
  return admin
}
